import { Box, Grid, IconButton, Hidden, makeStyles } from "@material-ui/core";
import { News } from "../../News";
import { swyftNews } from "./SwyftNews.constants";
import { useBreakpoint } from "../../../../../hooks/useBreakpoint";
import { color } from "../../../../../app/theme";
import Slider, { Settings } from "react-slick";
import { useRef, useState } from "react";

export const SwyftNews = ({ hasSpecialBackground }: { hasSpecialBackground?: boolean }) => {
  const { isLessThanSm, isMoreThanSm } = useBreakpoint();
  const classes = useStyles();
  const sliderRef = useRef<Slider>(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings: Settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_current, next) => setActiveSlide(next)
  };

  return (
    <Box className="box-container">
      <Box
        textAlign={"center"}
        fontSize={isMoreThanSm ? "28px" : "20px"}
        color={"#1e073f"}
        fontWeight={500}
        width={"100%"}
        mb={hasSpecialBackground ? 0 : isMoreThanSm ? "30px" : "30px"}
        mt={hasSpecialBackground ? 0 : isMoreThanSm ? "-60px" : "10px"}
        position={hasSpecialBackground ? "absolute" : "relative"}
        top={hasSpecialBackground ? "82px" : "inherit"}
      >
        <span className={classes.colorOrange}>Swyft Energy</span> News
      </Box>
      <Grid container>
        <Grid item xs={12} lg={2} />
        <Grid item xs={12} lg={8}>
          <Hidden smDown>
            <Grid container spacing={6}>
              {swyftNews.map((item, index) => (
                <Grid item xs={4} key={index}>
                  <News data={item} isCenter />
                </Grid>
              ))}
            </Grid>
          </Hidden>

          {isLessThanSm && (
            <Box position="relative" className={classes.customCarousel}>
              <Slider {...settings} ref={sliderRef}>
                {swyftNews.map((item, idx) => (
                  <Box key={idx} px={-2}>
                    <News data={item} isCenter />
                  </Box>
                ))}
              </Slider>

              {/* Arrows on Mobile */}
              <Box position="absolute" top="25%" left={-8} style={{ transform: "translateY(-50%)" }}>
                <IconButton
                  className={classes.btnSlider}
                  style={{ opacity: activeSlide === 0 ? 0.3 : 1 }}
                  onClick={() => sliderRef.current?.slickPrev()}
                  disabled={activeSlide === 0}
                >
                  <img src="images/arrow_down.svg" alt="Prev" style={{ rotate: "90deg", width: 24, height: 24 }} />
                </IconButton>
              </Box>
              <Box position="absolute" top="25%" right={-8} style={{ transform: "translateY(-50%)" }}>
                <IconButton
                  className={classes.btnSlider}
                  style={{ opacity: activeSlide === swyftNews.length - 1 ? 0.3 : 1 }}
                  onClick={() => sliderRef.current?.slickNext()}
                  disabled={activeSlide === swyftNews.length - 1}
                >
                  <img src="images/arrow_down.svg" alt="Next" style={{ rotate: "-90deg", width: 24, height: 24 }} />
                </IconButton>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>

      {isMoreThanSm && <Box mb={10} />}
    </Box>
  );
};

const useStyles = makeStyles({
  customCarousel: {
    "overflow": "initial",
    "maxWidth": 330,
    "margin": "auto",
    "& button[aria-label='Next']": {
      right: -30
    },
    "& button[aria-label='Previous']": {
      left: -30
    }
  },
  colorOrange: {
    color: color.orange
  },
  btnSlider: {
    "backgroundColor": color.orange,
    "width": "47px",
    "height": "47px",
    "padding": 0,
    "&:hover": {
      backgroundColor: color.orange
    }
  }
});
